import { GoHome, GoGift } from "react-icons/go";
import { CgProfile } from "react-icons/cg";
import { AiOutlineSetting } from "react-icons/ai";
import { Link } from "react-router-dom";
import { setTheme } from "../../reducers/userReducer";
import { useSelector } from "react-redux";

export default function Footer({ settingsColor, homeColor }) {
  const theme = useSelector(setTheme);

  return (
    <footer className="d-flex justify-content-between fixed-bottom align-items-center p-2 px-md-5" id="footer" style={{background:theme.background}}>
      <Link to="/home" className="link" style={{color:theme.text}}>
      <div className="d-flex flex-column align-items-center">
        <GoHome size="25px" color={homeColor} />
        <h6 style={{color:homeColor}}>Home</h6>
      </div></Link>
      <div className="d-flex flex-column align-items-center">
        <GoGift size="25px" />
        <h6>Refer</h6>
      </div>
      <div className="d-flex flex-column align-items-center">
        <CgProfile size="25px" />
        <h6>Profile</h6>
      </div>
      <Link to="/settings" className="link" style={{color:theme.text}}>
        <div className="d-flex flex-column align-items-center">
          <AiOutlineSetting size="25px" color={settingsColor}/>
          <h6 style={{color:settingsColor}}>Settings</h6>
        </div>
      </Link>
    </footer>
  );
}
